export class ProfileImageUpload {
  FileName: string;
  FileSize: number;
  FileType: string;
  LastModifiedTime: number;
  LastModifiedDate: Date;
  FileAsBase64: string;
}
